/**
 * GF "how it works" steps strip (.gf-steps → .st with auto 01/02/… numbering).
 * Replaces the byte-identical inline copies on the eSIM/VPN/Insurance/Transport/Tours pages.
 *
 * Steps arrive in three shapes depending on the page module:
 * `{ title, description }` (eSIM/Transport), `{ title, desc }` (VPN/Insurance/
 * Tours) and plain strings (provider howItWorks) — normalize all of them here
 * so the description never silently drops.
 *
 * @param {Array} steps  `{ title, description|desc }[]` or `string[]`
 */
export default function GfSteps({ steps = [] }) {
    return (
        <div className="gf-steps">
            {(steps || []).map((step, i) => {
                const title = typeof step === 'string' ? step : step?.title;
                const description = typeof step === 'string' ? '' : (step?.description || step?.desc);
                return (
                    <div className="st" key={i}>
                        <div className="n">{String(i + 1).padStart(2, '0')}</div>
                        <h3>{title}</h3>
                        {description && <p>{description}</p>}
                    </div>
                );
            })}
        </div>
    );
}
